import { AuthTokens, authTokensSchema } from 'types/auth';

const BASE = import.meta.env.VITE_SECURITY_SERVICE_URL!;

export const authService = {
  signIn: async (email: string, password: string): Promise<AuthTokens> => {
    const res = await fetch(`${BASE}/Connect/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!res.ok) throw new Error(`Erreur ${res.status}`);
    const data = await res.json();
    return authTokensSchema.parse(data);
  },
};
